import axios from "@/lib/axios";
import { CancelRequestParams } from "../types";

const createCancelRequest = (data: CancelRequestParams) => {
  return axios.post("/customer/flat_rates/cancel_request", data);
}

export default createCancelRequest;